import { Component } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faUser } from '@fortawesome/free-solid-svg-icons';

import { AuthComponent, LocalizeComponent } from '../../../shared/components';

@Component({
  selector: 'app-title',
  imports: [FontAwesomeModule, LocalizeComponent, AuthComponent],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {

  //#region Icons
  iconPhone = faPhone;
  iconUser = faUser;

  iconFacebook = faFacebook;
  iconInstagram = faInstagram;
  iconTiktok = faTiktok;
  //#endregion

}
